/* eslint-disable security/detect-object-injection */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import  { Suspense,useContext,useEffect,useState,useCallback } from 'react';
import { useDispatch ,useSelector} from 'react-redux';
import React from 'react';
import {logout,setUserType,verifyOtp} from '../pages/auth/authSlice'
// import {CognitoCurrentData,CognitoData} from '../CommonMethods/CognitoData'
import {Route,Navigate,Routes,useNavigate,useLocation} from 'react-router-dom';
import { 
    subscribeToAuthEvents, 
    syncSessionFromLocalStorage,
    getAuthItem,
    clearAuthSession
} from '../CommonMethods/authSession';
import { organizationusersList } from '../slices/apiSlice';
import GlobalContext from '../components/Context/GloablContext';
import AnimatedPage from '../components/Animation/AnimatedPage';
import LoginPage from '../pages/auth/LoginForm';
import { ComponentsBasedOnRole } from './_nav';
import Layout from '../components/Layout'
import SideBar from '../components/Layout/Sidebar';
import SearchEmptyScreen from '../components/SearchEmptyScreen';
import Profile from '../pages/Profile';
import ForgotResetPassword from '../pages/auth/LoginForm/Components/ForgotResetPassword';
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword';
import TrustBrowser from '../pages/auth/LoginForm/Components/TrustBrowser';
import UpdatePassword from '../pages/auth/LoginForm/Components/UpdatePassword';
import PageNotFound from '../pages/auth/LoginForm/Components/PageNotFound';
import Home from '../pages/auth/LoginForm/Components/Home';
import EmailVerificationScreen from '../CommonMethods/EmailAddressVerification';
import { handleEditMessageSent,handleTargetUserEditId } from '../redux/systemConfigSlice';
import Noroute from '../components/Noroutes/Noroutes';
import CustomOverLay from '../components/CustomOverLay';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';

export default function NavigationRoutes(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [loading, setloading] = useState(false)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [userType, setUserType] = useState(() => getAuthItem('user_type'));
    // Use storage for route matching so roles are correct immediately after login (avoids stale state for provider redirect)
    const effectiveUserType = getAuthItem('user_type');
    const rolesToMap = ComponentsBasedOnRole[effectiveUserType];
    const [isAuthenticating, setIsAuthenticating] =useState(true)
    const {editSocket,setEditSocket}=useContext(GlobalContext)



    const restrictroute = useSelector(state=>state?.systemConfigData?.restrict)
    const editingUserId = useSelector((state)=>state?.systemConfigData?.editingUserId)
    const messageSent = useSelector((state)=>state?.systemConfigData?.messageSent)

    useEffect(()=> {
        syncSessionFromLocalStorage();
        
        const syncedUserType = getAuthItem('user_type');
        if (syncedUserType !== userType) {
            setUserType(syncedUserType);
        }
        
        const idToken = getAuthItem('IdToken');
        if(idToken !== null){
            setIsLoggedIn(true);
            // Only finish authenticating when we have user_type (avoids redirect loop when opening email link in new tab)
            if (syncedUserType) {
                setIsAuthenticating(false);
            }
            if(getAuthItem('custom:is_first_time_login')==="true"){
                navigate('/reset')
            }else if(location.pathname === '/reset'){
                navigate('/profile')
            }
            
        }
        else{
            setIsLoggedIn(false);
            setIsAuthenticating(false)
        }
    }, [location, navigate, userType])

    // Fallback: if we have token but no user_type after a delay (e.g. deeplink in new tab with old session), clear session so user is redirected to login with redirect param instead of infinite loading
    useEffect(() => {
        const token = getAuthItem('IdToken');
        const uType = getAuthItem('user_type');
        if (token == null || uType != null) return;
        const timer = setTimeout(() => {
            const stillNoUserType = getAuthItem('user_type') == null;
            if (stillNoUserType && getAuthItem('IdToken') != null) {
                clearAuthSession();
                dispatch(logout());
                setIsLoggedIn(false);
                setIsAuthenticating(false);
            }
        }, 3000);
        return () => clearTimeout(timer);
    }, [location, dispatch]);

    
    // Check token directly for route rendering to avoid race conditions
    const hasToken = getAuthItem('IdToken') !== null;
    // Don't switch to authenticated routes if trust browser flow is active (prevents modal from disappearing)
    const trustBrowserFlowActive = sessionStorage.getItem('trust_browser_flow_active') === 'true';
    const isAuthenticated = (hasToken || isLoggedIn) && !trustBrowserFlowActive;
    // Avoid blank screen / redirect loop: authenticated layout needs rolesToMap; without it, show login
    const effectiveIsAuthenticated = isAuthenticated && rolesToMap != null;
    // Only show auth overlay when we have a token and are still resolving (e.g. user_type). No token = show login immediately without waiting for effect.
    const showAuthLoading = isAuthenticating && hasToken;

    // Clear invalid session when we have token but no user_type/rolesToMap (e.g. after browser reopen with stale token)
    // --- USEFFECT ANALYSIS & REWRITE ---

    /*
    1. First useEffect: Handles auto-logout & session clearing if we have a token or isLoggedIn,
    but NO rolesToMap and not authenticating. This is important for cleaning up stale sessions.

    2. Second useEffect: Subscribes to auth (login) events and resets api state, re-syncs session.
    This runs ONCE and is unrelated to the first useEffect.
    */

    useEffect(() => {
        if ((hasToken || isLoggedIn) && rolesToMap == null && !isAuthenticating) {
            clearAuthSession();
            dispatch(logout());
        }
    }, [hasToken, isLoggedIn, rolesToMap, isAuthenticating, dispatch]);

    useEffect(() => {
        const unsubscribe = subscribeToAuthEvents((eventType) => {
            if (eventType === 'login') {
                syncSessionFromLocalStorage();
                dispatch(organizationusersList.util.resetApiState());
            }
        });
        return unsubscribe;
    }, [dispatch])


    return (

        <Suspense fallback={<div></div>}>{
            <>
                {
                    showAuthLoading ? <div><CustomOverLay Active text="Loading ARCM Provider/Monitor Web Application" classKey="fixed top-0 left-0 right-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center text-white"/></div> :
                        (<Routes location={location}>
                            <Route path="/email-address-verification" element={
                                <AnimatedPage>
                                    <EmailVerificationScreen />
                                </AnimatedPage>
                            }/>
                            {!effectiveIsAuthenticated ? 
                                <>
                                    <Route path="/" element={
                                        <AnimatedPage><LoginPage /></AnimatedPage>} />
                                    <Route path="/reset" element={
                                        <AnimatedPage>
                                            <ResetPassword />
                                        </AnimatedPage>
                                    } />
                                    <Route path="/reset-new-password" element={
                                        <AnimatedPage><ForgotResetPassword /></AnimatedPage>} />
                                    <Route path="/404" element={
                                        <>
                                            <SearchEmptyScreen text={"404"} />
                                        </>} /> 
                                    <Route
                                        path="*"
                                        element={
                                            (() => {
                                                // Capture the full intended path (pathname + search) for redirect
                                                const intendedPath = location.pathname + location.search;
                                                const encodedRedirect = encodeURIComponent(intendedPath);
                                                return <Navigate replace to={`/?redirect=${encodedRedirect}`}/>;
                                            })()
                                        } />
                            
                                </>
                                :
                                <>

                                    <Route path="/" element={
                                        <AnimatedPage><Home /></AnimatedPage>} />

                                    
                                    <Route path="/reset" element={
                                        <AnimatedPage>
                                            <ResetPassword />
                                        </AnimatedPage>
                                    } />
                                    <Route  element={<Layout {...props}/>}>
                                        {
                                            rolesToMap !== undefined && rolesToMap.map((nav) => (
                                                <Route 
                                                    path={nav.path} 
                                                    element={
                                                        (restrictroute === 'true' || restrictroute === true) && nav.roleKey !== 'Profile' ? (
                                                            nav.roleKey === 'UpdatePassword' ? (
                                                                React.cloneElement(nav.element, props)
                                                            ) : (
                                                                <Navigate to="/profile" />
                                                            )
                                                        ) : (
                                                            React.cloneElement(nav.element, props)
                                                        )
                                                    }
                                                    key={nav.path} 
                                                />
                                            ))
                                        }
                                    </Route>
                                    <Route
                                        path="*"
                                        element={
                                            (() => {
                                                const intendedPath = location.pathname + location.search;
                                                const encodedRedirect = encodeURIComponent(intendedPath);
                                                return <Navigate replace to={`/?redirect=${encodedRedirect}`} />;
                                            })()
                                        } />
                            
                                </>
                            }
                            <Route
                                path="*"
                                element={
                                    <Noroute/>
                                } 
                            />
                        </Routes>)}
            </>
        }</Suspense>

    );
}